import React, {useEffect, useState} from "react";
import Modal from 'react-modal';
import ReactLoading from 'react-loading';
import * as PetApi from "../../api/apiPet.js";
import * as PhotoApi from "../../api/apiPhotos.js";
import * as UserApi from "../../api/apiUser.js";
import {  useDispatch } from "react-redux";
import { setPetData } from "../../redux/actions/petActions.js";
import { setUserData } from "../../redux/actions/userActions.js";

/**
 * Componente que muestra un modal para editar el perfil de un usuario
 * (cambio de nombre, teléfono y foto de perfil) 
 */
const EditProfileModal = ({user, pets, open, onClose}) => {
    const [name, setName] = useState(user.name);
    const [phone, setPhone] = useState(user.phone);
    const [profilePicture, setProfilePicture] = useState<File | null>(null);
    const [petsList, setPetsList] = useState(pets);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    const updateProfilePhoto = async () => {
        if(profilePicture) {
            setLoading(true);
            const res = await PhotoApi.uploadProfilePhoto(user.uid, profilePicture);
            setLoading(false);
            if (res) {
                const _user = await UserApi.getUser(user.uid);
                dispatch(setUserData(_user));
                onClose();
            } else {
                alert("Error al actualizar la foto de perfil");
            }
        }
    }

    const deletePet = async (petId) => {
        try {
            setLoading(true);
            await PetApi.deletePet(petId);
            const pets = await PetApi.getPetsByOwner(user.uid);
            dispatch(setPetData(pets));
            setPetsList(pets);
            setLoading(false);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <Modal
            isOpen={open}
            contentLabel="Editar perfil"
            onRequestClose={onClose}
            style={{
                overlay: {
                    zIndex: 2,
                }
            }}
        >
            <div className="modal-content">
                <form
                    onSubmit={(e) => {
                        e.preventDefault();
                        setLoading(true);
                        setTimeout(() => {
                            setLoading(false);
                            onClose();
                        }, 2000);
                    }}
                    style={{
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <h2>Editar perfil</h2>
                    <label>Nombre</label>
                    <input
                        type="text"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                    />
                    <label>Teléfono</label>
                    <input
                        type="text"
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                    />
                    <button type="submit">Guardar</button>
                </form>
                {/** forms para subir foto de perfil y visualizar esta antes de cambiarla */}
                <div>
                    <h2>Foto de perfil</h2>
                    {profilePicture && (
                        <img
                            src={URL.createObjectURL(profilePicture)}
                            alt="Foto de perfil"
                            style={{
                                width: "100px",
                                height: "100px",
                                objectFit: "cover",
                            }}
                        />
                    )}
                    <input 
                        type="file" 
                        accept="image/*"
                        onChange={(e) => {
                            if (e.target.files) {
                                setProfilePicture(e.target.files[0]);
                            }
                        }}
                    />
                    <button
                        onClick={() => {
                            updateProfilePhoto();
                        }}
                    >Actualizar Foto</button>
                </div>         
                <div>
                    <h2>Mis mascotas</h2>
                    {petsList.length === 0 && <p>No tienes mascotas registradas</p>}
                    <ul>
                        {petsList.map((pet) => (
                            <li key={pet.id}>
                                <span>{pet.name}</span>
                                <button
                                    onClick={() => {
                                        const userResponse = window.confirm(
                                            `¿Estás seguro de borrar a ${pet.name}?`
                                        );
                                        if (userResponse) {
                                            deletePet(pet.id);
                                        }
                                    }}
                                >Borrar</button>
                            </li>
                        ))}
                    </ul>
                </div>
                {loading && (
                    <div style={{
                        position: "absolute",
                        top: 0,
                        bottom: 0,
                        left: 0,
                        right: 0,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(255, 255, 255, 0.7)",
                        zIndex: 3,
                        }}>
                    <ReactLoading
                        type={"spinningBubbles"}
                        color={"#000000"}
                        height={50}
                        width={50}
                    />
                    </div>
                )}
            </div>
        </Modal>
    );


}

export default EditProfileModal;